/* eslint-disable */
// Tried to refactor this in order to avoid eslint errors, however
// the functionality was breaking.
const EVENTS = {
  FLAG_CHANGED: [],
  PUBMED_CHANGED: [],
  DECLARATION_MODIFIED: [],
};

let Events = {
  events: EVENTS,

  subscribe: function (name, self, f, args = []) {
    this.events[name].push({ self, f, args });
  },

  dispatch: function (name, args = []) {
    for (let i = 0; i < this.events[name].length; i++) {
      const sub = this.events[name][i];
      const fArgs = sub.args.concat(args);
      sub.f.apply(sub.self, sub.args);
    }
  },
};

export default Events;
